import axios from 'axios';

/** One line of the registered firmateckning wording; `indent` marks a named person/role entry. */
export type SignatoryRuleLine = {
  text: string;
  indent: 0 | 1;
};

export type SignatoryPerson = {
  name: string;
  roleText: string;
};

export type SignatoryMatch = {
  signeeName: string;
  registryName: string;
  roleText: string;
  isCeo: boolean;
};

/**
 * `ok`       - the selected signees satisfy the registered rule (or one of them is CEO)
 * `mismatch` - they do not, or a signee is not registered at the company at all
 * `unknown`  - no machine-readable rule (CreditSafe source, or wording the parser can't read)
 * `none`     - no signees selected yet
 */
export type SigningStatus = 'ok' | 'mismatch' | 'unknown' | 'none';

export type SignatoryCheck =
  | {
      status: 'ok';
      source: 'syna' | 'creditsafe';
      hasRule: boolean;
      ruleLines: SignatoryRuleLine[];
      people: SignatoryPerson[];
      signing: {
        status: SigningStatus;
        viaCeo: boolean;
        matched: SignatoryMatch[];
        unmatched: string[];
      };
    }
  | { status: 'no_credit_service' | 'not_found'; source: null };

class ServiceSignatoryController {
  /**
   * Registered signatories for a company, plus an advisory check of the proposed signees.
   * Purely informational — callers must never gate submission on the result.
   */
  async checkSignatories(organizationNumber: string, signeeNames: string[]): Promise<SignatoryCheck> {
    const response = await axios.post('/api/contract/signatory-check', {
      organizationNumber,
      signeeNames,
    });
    return response.data;
  }
}

export const ServiceSignatory = new ServiceSignatoryController();
